/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import faker from 'faker';
import { Factory, association } from 'miragejs';

const billingSetting = Factory.extend({
  id: () => faker.datatype.uuid(),
  account: association(),
  is_delinquent: () => false,
  ignore_delinquent_check: () => false,
});

export default billingSetting;
